/* eslint-disable prettier/prettier */
/* eslint-disable no-alert */
/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable no-empty-function */
/* eslint-disable no-new */
/* eslint-disable eqeqeq */
/* eslint-disable no-empty */
/* eslint-disable no-restricted-globals */
/* eslint-disable radix */
import { isProd } from 'config/config';
import { getBackOrders, backOrdersCancellationRequest } from 'helpers/api';
import { formatDate, formatMoney, formatCityName } from 'helpers/utils';
import swal from 'sweetalert';

import Vue from 'vue/dist/vue';

const backordersEl = document.querySelector('#backorders');
if (backordersEl) {
    new Vue({
        el: '#backorders',
        data: {
            res: null,
            liElement: '',
            isLoading: true,
            searchFilter: '',
            pageSize: 20,
            currentPage: 1,
            paginationInput: 1,
            backOrderCancelToggle: false,
            cancelName: null,
            cancelEmail: null,
            disableSubmit: true,
            cancelReasonList: [
                'End User Canceled Order',
                'Purchased from another dealer',
                'Purchased from online site',
                'Backorder ETA too far out will reorder',
                'Other',
            ],
            itemLocationInventory: null,
            isPopupVisible: false,
            selectedPartForPopup: null,
            isAlternateWarehouseDisabled: true,
        },
        computed: {
            backorderedItems() {
                if (this.res) {
                    const searchFilterLower = this.searchFilter.toLowerCase();
                    return this.res.filter((order) => {
                        var searchString =
                            `${order.manufacturerCode} ${order.partNumber} ${order.partDescription} ${order.customerPONumber} ${order.salesOrder}`.toLowerCase();

                        return !this.searchFilter || searchString.indexOf(searchFilterLower) >= 0;
                    });
                }
                return [];
            },
            disablePreviousLink() {
                return this.currentPage <= 1;
            },
            disableNextLink() {
                return this.currentPage >= this.totalNumOfPages;
            },
            visibleBackorders() {
                return this.backorderedItems.slice(
                    (this.currentPage - 1) * this.pageSize,
                    (this.currentPage - 1) * this.pageSize + this.pageSize,
                );
            },
            totalNumOfPages() {
                const filledPages = Math.floor(this.backorderedItems.length / this.pageSize);
                const remainder = this.backorderedItems.length % this.pageSize;

                if (remainder) {
                    return filledPages + 1;
                }
                return filledPages;
            },
            visibleOrdersLow() {
                if (!this.backorderedItems.length) {
                    return 0;
                }
                return this.pageSize * this.currentPage - (this.pageSize - 1);
            },
            visibleOrdersHigh() {
                if (this.currentPage == this.totalNumOfPages) {
                    return this.backorderedItems.length;
                }
                return this.currentPage * this.pageSize;
            },
        },
        filters: {
            formatDate(date) {
                if (!date) {
                    return 'Pending';
                }
                return formatDate(date);
            },
            formatMoney(price) {
                return formatMoney(price);
            },
            formatOrderDetailsURL(order) {
                const link = isProd ? '/portal/order-details' : '/order-details.html';
                return link + '?orderNumber=' + order;
            },
            formatCityName: function (city) {
                return formatCityName(city);
            },
        },
        methods: {
            async setValues() {
                const response = await getBackOrders();
                this.res = response.data.Orders;
                this.itemLocationInventory = response.data.ItemLocationInventory;
                this.isAlternateWarehouseDisabled = response.data.IsAlternateWarehouseDisabled;
                this.isLoading = false;
            },
            previousPage() {
                this.currentPage -= 1;
                this.paginationInput = this.currentPage;
            },
            nextPage() {
                this.currentPage += 1;
                this.paginationInput = this.currentPage;
            },
            validatePaginationInput() {
                if (this.paginationInput === '') {
                } else if (
                    isNaN(this.paginationInput) ||
                    this.paginationInput > this.totalNumOfPages ||
                    this.paginationInput <= 0
                ) {
                    this.paginationInput = this.currentPage;
                } else {
                    const input = parseInt(this.paginationInput);
                    this.currentPage = input;
                    this.paginationInput = input;
                }
            },
            refreshPage() {
                if (this.backorderedItems) {
                    this.currentPage = 1;
                    this.paginationInput = 1;
                } else {
                }
            },
            formatOrderURL(order) {
                const link = isProd ? '/portal/order-details' : '/order-details.html';
                return link + '?orderNumber=' + order;
            },
            validateEmail(email) {
                const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return regex.test(email);
            },
            selectLine(item, index) {
                Vue.set(item, 'selected', !item.selected);
            },
            async SubmitCancellationRequest() {
                if (this.cancelName == null || this.cancelName === '') {
                    swal('Required', 'Name is required field.', 'warning');
                    return;
                }
                if (this.cancelEmail == null || this.cancelEmail === '') {
                    swal('Required', 'Email is required field.', 'warning');
                    return;
                }
                this.isEmailValid = this.validateEmail(this.cancelEmail);
                if (!this.isEmailValid) {
                    swal('Invalid Email', 'Please enter a valid email address.', 'warning');
                    return;
                }
                const BOCancellationLineItems = [];
                const requestObject = {};
                for (let index = 0; index < this.res.length; index++) {
                    const item = this.res[index];
                    if (item.selected) {
                        if (item.cancelReasonSelected == null) {
                            swal(
                                'Required',
                                'Please select reason to cancel this order.',
                                'warning',
                            );
                            return;
                        }
                        if (item.lineinternalid == null) {
                            swal('Required', 'line Internal Id field is required.', 'warning');
                            return;
                        }
                        if (item.uniqueid == null) {
                            swal('Required', 'unique Id is a required.', 'warning');
                            return;
                        }
                        if (item.transactioninternalid == null) {
                            swal(
                                'Required',
                                'Transaction Internal Id is a required field.',
                                'warning',
                            );
                            return;
                        }
                        if (item.customer == null) {
                            swal('Required', 'Customer is required a field.', 'warning');
                            return;
                        }

                        const retValItem = {
                            NetSuiteItemId: item.netSuiteItemId,
                            TransactionLineId: item.lineinternalid,
                            TransactionInternalId: item.transactioninternalid,
                            CancellationReason: item.cancelReasonSelected,
                            SalesOrderNumber: item.salesOrder,
                            PONumber: item.customerPONumber,
                        };

                        BOCancellationLineItems.push(retValItem);
                    }
                }
                requestObject.BOCancellationLineItems = BOCancellationLineItems;
                requestObject.Name = this.cancelName;
                requestObject.Email = this.cancelEmail;

                if (requestObject.BOCancellationLineItems.length == 0) {
                    swal('Required', 'Please select order(s) for order cancellation.', 'warning');
                    return;
                }

                await swal({
                    title: 'Are you sure you want to submit this cancellation request?',
                    text: '',
                    icon: 'warning',
                    buttons: ['Go Back', 'Submit Cancellation Request'],
                    dangerMode: true,
                })
                    .then(async (willDelete) => {
                        if (willDelete) {
                            this.isLoading = true;
                            const postRequest = await backOrdersCancellationRequest(requestObject);
                            if (postRequest.status === 200) {
                                console.log(postRequest.data.length, postRequest.data);
                                var liElement = '';
                                if (postRequest.data && postRequest.data.length) {
                                    var wrapper = document.createElement('div');
                                    for (let index = 0; index < postRequest.data.length; index++) {
                                        liElement =
                                            liElement + '<p>' + postRequest.data[index] + '</p>';
                                    }
                                    wrapper.innerHTML =
                                        'Following parts are not cancellable. ' + liElement;
                                    liElement = '<div>' + liElement + '</div>';
                                    var swalOptions = {
                                        icon: 'warning',
                                        dangerMode: true,
                                        content: wrapper,
                                    };
                                    console.log('LiElement', liElement);
                                    swal(swalOptions);
                                } else {
                                    swal(
                                        'Success',
                                        'Your cancellation request has been submitted.',
                                        'success',
                                    );
                                }
                                this.setValues();
                            }
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                    });
            },
            navigateToOrder(salesOrder) {
                const url = this.formatOrderURL(salesOrder);
                window.location.href = url;
            },
            alternateWarehouseInventoryPopUp(part) {
                this.selectedPartForPopup = part;
                this.isPopupVisible = true;
            },
            closePopup() {
                this.isPopupVisible = false;
                this.selectedPartForPopup = null;
            },
        },
        created() {
            this.setValues();
        },
        actions: {},
    });
}

async function init() { }

export default init;



// WEBPACK FOOTER //
// ./app/js/modules/backorders.js